import React, { Component } from 'react'
import { connect } from 'react-redux';

import { telehealthService as service } from '../../../../_services/telehealth.service';

import { telehealthActions } from '../../../../_actions/telehealth.actions'
import PusherContext from '../../../../_contexts/PusherContext';

const withDataService = (WrappedComponent) => {
  class DataService extends Component
  {  
    static contextType = PusherContext

    constructor(props) {
      super(props)

      this.addMessage = this.addMessage.bind(this)
      this.handleLink = this.handleLink.bind(this)
      this.handleMessage = this.handleMessage.bind(this)
      this.handleAttachment = this.handleAttachment.bind(this)
      this.handleStartTelehealth = this.handleStartTelehealth.bind(this)
    }

    handleLink(link) {
      const socketId = this.context.connection.socket_id ?? null

      return service.sendLink(this.props.telehealth.id, link, socketId).then(this.addMessage)
    }

    handleMessage(message) {
      const socketId = this.context.connection.socket_id ?? null

      return service.sendMessage(this.props.telehealth.id, message, socketId).then(this.addMessage)
    }

    handleAttachment(attachment) {
      const socketId = this.context.connection.socket_id ?? null

      return service.sendAttachment(this.props.telehealth.id, attachment, socketId).then(this.addMessage)
    }

    addMessage (data) {
      const message = {
        sentBy: data.from,
        sentAt: data.sent_at,
        ...data
      }
      this.props.dispatch(telehealthActions.addTelehealthMessage(message))
    }

    handleStartTelehealth () {
      return service.startTelehealth(this.props.telehealth)
    }

    render() {
      return <WrappedComponent
        {...this.props}
        sendLink={this.handleLink}
        sendMessage={this.handleMessage}  
        sendAttachment={this.handleAttachment}
        startTelehealth={this.handleStartTelehealth}
      />
    }
  }

  const mapStateToProps = state => {
    return {
      currentUser: state.user.currentUser,
      messages: state.telehealth.current.messages
    }
  }

  return connect(mapStateToProps)(DataService)
}

export default withDataService